import Box from "@mui/material/Box";
import { PADDING_DESKTOP, PADDING_MOBILE } from "../../utils/constants";

const ContainerPage = ({
  children,
  sx,
  mode = "margin",
  hasMarginBottom = false,
}) => {
  const sxPersonalized =
    mode === "margin"
      ? {
          px: {
            md: PADDING_DESKTOP,
            xs: PADDING_MOBILE,
          },
        }
      : {
          px: {
            md: PADDING_DESKTOP,
            xs: PADDING_MOBILE,
          },
        };
  return (
    <Box
      sx={{
        backgroundColor: "#fcfcfc",
        ...sxPersonalized,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        // maxWidth: `calc(100% - ${PADDING_MOBILE * 8}px)`,
        pb: hasMarginBottom ? 15 : 3,
        height: "100%",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ContainerPage;
